module.exports = __webpack_public_path__ + "static/media/fly0285.9ee1a7f6.webp";